<template>
  <v-main>
    <TermsHeader title="アカウント 利用規約" />

    <v-container style="margin-top: 50px;">
      <v-row class="pb-5 ml-1">
        2019年 10月 1日 発行
      </v-row>


      <TermsContent
        title="第1条（規約の定義と適用）"
        ol
      >
        <li>
          OCH POWERアカウント利用規約（以下「本規約」といいます。）は、OCH株式会社（以下「当社」といいます。）が提供する、複数サービスを統合的に利用できる、「OCH
          POWER」に関する条件を定めるものです。
        </li>
        <li>OCH POWERアカウントには、本規約に加え、OCH POWERアカウントの個別サービスの規約が合わせて適用されます。</li>
        <li>
          お客さまは本サービスを利用することにより、本規約に同意することになります。また、本サービスの利用に際しては、本サービス規約の他、個別規約、注意事項、ガイドライン、仕様書など(以下、併せて『個別規約』といいます)が適用されます。個別規約は名称
          の如何にかかわらず本サービス規約の一部を構成するものとし、本規約の規定と、個別規約の規定とが異なる場合には、個別規約の規定が優先して適用されるものとします。
        </li>
        <li>お客さまは、本規約、個別規約に従ってOCH POWERアカウントを利用しなければなりません。また、お客さまは、OCH POWERアカウントの利用に際して、適用のあるすべての法令を遵守する責任を負います。</li>
      </TermsContent>


      <TermsContent
        ol
        title="第2条（本サービス規約）"
      >
        <li>お客さまは、本サービスを利用しようとする場合は、本サービス規約の内容を承諾のうえ、当社所定の方法により、本サービスの利用を申込む必要があります。</li>
        <li> 本サービスの利用に関わる契約は、当社がお客さまからの前項の申し込みを承諾した旨を、当社所定の方法により、お客さまに通知した時点をもって成立するものとします。</li>
        <li> 当社は、次の各号のいずれかに該当する場合、本サービスの利用の申し込みを承諾しないことがあります。</li>
        <ol
          style="list-style-type: lower-roman"
          class="pl-4"
        >
          <li>申込書の記載に虚偽の内容がある場合、または不備がある場合</li>
          <li>お客さまが、当社と締結した契約などに基づく契約解除を受けたことがある場合</li>
          <li>その他、申し込みを承諾することが不適当であると当社が判断するにつき相当の理由がある場合</li>
        </ol>
      </TermsContent>


      <TermsContent title="第3条（本規約の変更）">
        当社は、必要に応じ、お客さまに公表または通知することにより、本規約およびOCH POWERアカウントが提供するサービスの内容等を変更できるものとします。お客さまが、変更後引き続きOCH
        POWERアカウントを利用した場合、本規約およびサービス内容等の変更に同意したものとみなされます。
      </TermsContent>


      <TermsContent
        ol
        title="第4条（IDおよびパスワード）"
      >
        <li>お客さまは、本サービスを利用するために、お客さまが本サービスの申込時に指定したID および当社所定の方法によりお客さまが指定したパスワードを本サイトに入力する必要があります。</li>
        <li>特定の ID とこれに関わるパスワードが入力された本サービスのご利用については、当該 ID およびパスワードの利用者として当社に登録された者による利用とみなします。</li>
        <li>
          当社は、当社の責に帰すべき事由による場合を除き、第三者による ID およびパスワードの不正使用を含め、ID
          およびパスワードの利用・管理、およびお客さまに生じたあらゆる損害または費用(弁護士費用を含みます)について何ら責任を負いません。
        </li>
      </TermsContent>


      <TermsContent
        ol
        title="第5条（利用の一時中断など）"
      >
        <li>当社は、次のいずれかに該当する場合には、お客さまの同意を得ることなく、本サービスの一部もしくは全部の利用を一時中断、または一時停止することができます。</li>
        <ol
          style="list-style-type: lower-roman"
          class="pl-4"
        >
          <li>本サービスを提供するために使用するネットワークもしくは設備を工事または保守する必要がある場合</li>
          <li>火災・停電・天災などの不可抗力により、当社の責に帰すことができない事由に起因して本サービスの提供が不能または困難になった場合</li>
          <li>その他、当社が合理的な事由により、本サービスの利用を一時中断、または一時停止する必要があると判断した場合</li>
        </ol>
        <li>前項に基づき当社が行った本サービスの一時中断または一時停止に関して、当社はお客さままたは第三者に対していかなる責任も負いません。</li>
      </TermsContent>


      <TermsContent title="第6条（利用停止）">
        当社は、次のいずれかに該当する場合は、当該お客さまに事前に何ら通知することなく、当該お客さまによる本サービスの利用を停止することができます。
        <ol
          style="list-style-type: lower-roman"
          class="pl-4"
        >
          <li>お客さまが過去にまたは現に本サービス規約もしくは個別規約に違反し、または次条のいずれかに該当したと当社が判断した場合</li>
          <li>ID またはパスワードの不正利用が疑われる場合</li>
          <li>その他、当社が合理的な事由により、当該お客さまに本サービスを提供することが不適当と判断した場合</li>
        </ol>
      </TermsContent>


      <TermsContent title="第7条（禁止行為）">
        お客さまは、本サービスの利用に関して、以下の行為をしてはなりません。
        <ol
          style="list-style-type: lower-roman"
          class="pl-4"
        >
          <li>当社または第三者の名前、商号その他の情報を不正利用する行為</li>
          <li>当社または第三者の特許権・商標権・著作権その他知的財産権などを侵害する行為</li>
          <li>当社または第三者の企業機密などを漏えいまたは不正に利用する行為</li>
          <li>犯罪行為またはこれに関与する行為、本サービスの運営・提供もしくは他のお客さまによる本サービスの利用を妨害し、またはそれらに支障をきたす行為</li>
          <li>当社と別段の合意がある場合を除き、当社が提供するインターフェース以外の手で本サービスにアクセスし、またはアクセスを試みる行為</li>
          <li>
            本サイトについて転載・複製・複写・修正・改変・公衆送信・頒布・貸与・翻訳・翻案・二次的著作物の作成、リバースエンジニアリング、逆コンパイル、逆アセンブル、その他の利用を行うことおよびこれらの行為を第三者に行わせること
          </li>
          <li>本サービスの利用に関する権利義務の一部または全部を第三者に譲渡し、または自己もしくは第三者のために担保に供すること</li>
          <li>法令または公序良俗に違反する行為</li>
          <li>その他当社が合理的な理由に基づき不適切と判断する行為</li>
        </ol>
      </TermsContent>


      <TermsContent
        ol
        title="第8条（情報の取り扱い）"
      >
        <li>お客さまは、当社が本サービスに関して取得するお客さまの情報を、本サービスの提供(当社他サービスに関する情報提供を含みます)、運営および管理などのために利用することに同意するものとします。</li>
        <li>
          当社は、前項のお客さまの情報を適正に扱うものとし、当該情報のうち個人情報に該当するものについては、当社が別に公表する『プライバシーポリシー』（https://www.och.co.jp/privacypolicy/）にしたがって取り扱うものとします。
        </li>
      </TermsContent>


      <TermsContent
        ol
        title="第9条（免責事項）"
      >
        <li>当社は、本サービスの内容および結果について、その正確性・完全性・安全性・最新性・合法性・道徳性などのいかなる事項に関して何ら保証するものではありません。</li>
        <li>当社は、本サービスの利用に関して、お客さまの行為により生じたあらゆる責任、損害または費用(弁護士費用を含みます)について、一切責任を負わないものとします。</li>
        <li>
          当社は、お客さまへの通知を行うことなく、本サービスの一部または全部を変更・中止・終了することができるものとします。当社は、本サービスの変更・中止・終了またはサービス提供条件の変更などによりお客さまに発生した損失や損害について、一切責任を負わないものとします。
        </li>
      </TermsContent>


      <TermsContent title="第10条（損害賠償など）">
        本サービスの利用に当たり当社の責に帰すべき事由によりお客さまが損害を被った場合は、当社は、通常生ずべき損害または当該損害の発生の直接の原因となった取引に関してお客さまが当社に実際に支払った代金相当額の低い方を上限として、当該損害を賠償するものとします。
      </TermsContent>


      <TermsContent title="第11条（準拠法）">
        本サービス規約および個別規約の成立・効力・履行および解釈に関しては、日本国法が適用されるものとします。
      </TermsContent>


      <TermsContent
        ol
        title="第12条（その他）"
      >
        <li>本サービスの利用に関して、お客さまと当社との間で問題が発生した場合は、お客さまと当社とで協議を行い、これを解決するものとします。</li>
        <li>前項にも関わらず、本サービスの利用に関してお客さまと当社との間で訴訟などの必要が生じた場合は、那覇地方裁判所を合意上の管轄裁判所とします。</li>
      </TermsContent>
    </v-container>
  </v-main>
</template>

<script>
import TermsHeader from '@/terms/TermsHeader'
import TermsContent from '@/terms/TermsContent'

export default {
  name: 'TermsEn',
  components: { TermsContent, TermsHeader },
  props: {}
}
</script>

<style>
li {
  margin-bottom: 15px;
  margin-left: 16px;
}
</style>
